function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { ConfirmationModal, TextField, Typography } from 'seagull';
import { isUrlValid } from "./IntroVIdeoModal.utils";
import styles from "./IntoVideoModal.module.scss";
import VideoPlayer from "../../../VideoPlayer/VideoPlayer";
import { Controller, useForm } from 'react-hook-form';
import { connectControllerToTextField } from "../../../../utils/react-hook-form.utils";
const IntroVideoModal = _ref => {
  let {
    dismissModal,
    onSave,
    videoLink
  } = _ref;
  const form = useForm({
    mode: 'all',
    defaultValues: {
      videoLink: videoLink || ''
    }
  });
  const [inputVideoName, setInputVideoName] = useState('');
  const [isVideoPlayable, setIsVideoPlayable] = useState(false);
  const handleReady = () => {
    form.clearErrors();
    setIsVideoPlayable(true);
  };
  const handleError = () => {
    setIsVideoPlayable(false);
  };
  const onError = () => {
    handleError();
  };
  const onReady = _ref2 => {
    let {
      videoName
    } = _ref2;
    handleReady();
    setInputVideoName(videoName);
  };
  const onSubmit = () => {
    const inputVideoLink = form.getValues('videoLink');
    if (isUrlValid(inputVideoLink) && isVideoPlayable) {
      onSave(inputVideoName, inputVideoLink);
      dismissModal();
    }
  };
  const onCancel = () => {
    dismissModal();
  };
  const validateVideoLinkField = videoLinkToValidate => {
    if (!isUrlValid(videoLinkToValidate)) {
      setInputVideoName('');
      return 'URL is invalid';
    }
    if (!isVideoPlayable) {
      setInputVideoName('');
      return 'Video was not found';
    }
  };
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    "data-testid": "intro-video-modal",
    textAlignCenter: false,
    title: "Add an introductory video",
    secondaryButtonTestid: "intro-video-modal-cancel-button",
    onSecondaryButtonClick: onCancel,
    primaryButtonTestid: "intro-video-modal-save-button",
    onPrimaryButtonClick: onSubmit,
    onCloseButtonClick: onCancel,
    primaryButtonLabel: "Save",
    secondaryButtonLabel: "Cancel",
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.contentContainer
    }, /*#__PURE__*/React.createElement(Typography, null, "Paste the video URL from Youtube, Vimeo or Loom"), /*#__PURE__*/React.createElement(Controller, {
      control: form.control,
      name: "videoLink",
      rules: {
        validate: value => validateVideoLinkField(value)
      },
      render: p => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, _extends({
        "data-testid": "intro-video-modal-url-field",
        placeholder: "Video URL",
        autoFocus: true
      }, connectControllerToTextField(p))), isUrlValid(p.field.value) && /*#__PURE__*/React.createElement("div", {
        style: {
          display: isVideoPlayable ? 'inherit' : 'none',
          minHeight: 300
        }
      }, /*#__PURE__*/React.createElement(VideoPlayer, {
        url: p.field.value,
        onError: onError,
        onReady: onReady
      })))
    }))
  });
};
export default IntroVideoModal;